export const MAX_CORRECTNESS_FIX_ATTEMPTS = 3;
